import { combineReducers } from 'redux';
import login from './LoginReducer';


export default combineReducers({
    login

});



// WEBPACK FOOTER //
// ./src/reducers/index.js